module.exports = __webpack_public_path__ + "img/stealth-mode-bg-upper.02e39929.png";